import { createSlice } from "@reduxjs/toolkit";
import {
  fetchWalletAccount,
  fetchWalletTier,
  fetchPointsHistory,
  fetchGoogleWalletQrCode,
  fetchAppleWalletQrCode,
  fetchWalletDesign,
} from "../Thunks/WalletThunk";

export const walletSlice = createSlice({
  name: "wallet",
  initialState: {
    isLoading: false,
    accountInfo: null,
    balance: 0,
    tier: "Bronze",
    tierId: null,
    pointsHistory: [],
    googleQrCode: "",
    appleQrCode: "",
    walletDesign: [],
    error: null,
  },
  reducers: {
    setAccountInfo: (state, action) => {
      state.accountInfo = action.payload;
    },
    setBalance: (state, action) => {
      state.balance = action.payload;
    },
    setTier: (state, action) => {
      state.tier = action.payload;
    },
    setTierId: (state, action) => {
      state.tierId = action.payload;
    },
    setPointsHistory: (state, action) => {
      state.pointsHistory = action.payload;
    },
    setGoogleQrCode: (state, action) => {
      state.googleQrCode = action.payload;
    },
    setAppleQrCode: (state, action) => {
      state.appleQrCode = action.payload;
    },
    addPointsHistory: (state, action) => {
      state.pointsHistory.unshift(action.payload);
    },
    setWalletDesign: (state, action) => {
      state.walletDesign = action.payload;
    },

    clearWalletError: (state) => {
      state.error = null;
    },
    resetWalletState: (state) => {
      state.accountInfo = null;
      state.balance = 0;
      state.tier = "Bronze";
      state.pointsHistory = [];
      state.walletDesign = [];
      state.error = null;
      state.googleQrCode = "";
      state.appleQrCode = "";
    },
  },
  extraReducers: (builder) => {
    // Fetch Wallet Account
    builder.addCase(fetchWalletAccount.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(fetchWalletAccount.fulfilled, (state, action) => {
      state.isLoading = false;
      state.accountInfo = action.payload;
      state.tierId = action.payload?.user?.tier_id;
    });
    builder.addCase(fetchWalletAccount.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });

    // Fetch Wallet Tier
    builder.addCase(fetchWalletTier.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(fetchWalletTier.fulfilled, (state, action) => {
      state.isLoading = false;
      state.tier = action.payload?.tier_name;
    });
    builder.addCase(fetchWalletTier.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });

    // Fetch Points History
    builder.addCase(fetchPointsHistory.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(fetchPointsHistory.fulfilled, (state, action) => {
      state.isLoading = false;
      state.pointsHistory = action.payload;
    });
    builder.addCase(fetchPointsHistory.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });

    // Fetch Google Wallet QR Code
    builder.addCase(fetchGoogleWalletQrCode.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(fetchGoogleWalletQrCode.fulfilled, (state, action) => {
      state.isLoading = false;
      state.googleQrCode = action.payload;
    });
    builder.addCase(fetchGoogleWalletQrCode.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });

    // Fetch Apple Wallet QR Code
    builder.addCase(fetchAppleWalletQrCode.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(fetchAppleWalletQrCode.fulfilled, (state, action) => {
      state.isLoading = false;
      state.appleQrCode = action.payload;
    });
    builder.addCase(fetchAppleWalletQrCode.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });

    // Fetch Wallet Design
    builder.addCase(fetchWalletDesign.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(fetchWalletDesign.fulfilled, (state, action) => {
      state.isLoading = false;
      state.walletDesign = action.payload;
    });
    builder.addCase(fetchWalletDesign.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export const {
  setAccountInfo,
  setBalance,
  setTier,
  setTierId,
  setPointsHistory,
  addPointsHistory,
  clearWalletError,
  resetWalletState,
} = walletSlice.actions;

export default walletSlice.reducer;
